module.exports = __webpack_public_path__ + "static/select_your_sport_mobile-f5d8b3cab1b83a6f7371029dd3b96f99.jpg";